/**
 * Cleans and normalizes HTML content from rich text editors
 * Fixes issues with malformed lists by respecting data-list attributes
 * and breaking lists into separate ol/ul elements as needed
 */
export function cleanHtmlContent(html) {
    if (!html) return html;

    // Parse the HTML string into a DOM-like structure
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    // Find all lists (ol, ul) and rebuild them respecting data-list attributes
    const lists = doc.querySelectorAll('ol, ul');
    lists.forEach((list) => {
        const listItems = Array.from(list.querySelectorAll(':scope > li'));

        if (listItems.length === 0) return;

        // Group consecutive items by their data-list type
        const groups = [];
        let currentGroup = {
            type: listItems[0].getAttribute('data-list') || 'ordered',
            items: []
        };

        listItems.forEach(li => {
            const dataList = li.getAttribute('data-list') || 'ordered';

            // If type changes, start a new group
            if (dataList !== currentGroup.type) {
                groups.push(currentGroup);
                currentGroup = {
                    type: dataList,
                    items: []
                };
            }

            currentGroup.items.push(li.cloneNode(true));
        });

        // Don't forget the last group
        groups.push(currentGroup);

        // Rebuild lists from groups
        let previousNode = list;
        groups.forEach(group => {
            const listType = group.type === 'bullet' ? 'ul' : 'ol';
            const newList = doc.createElement(listType);

            // Add items to the new list and remove data-list attributes
            group.items.forEach(item => {
                item.removeAttribute('data-list');
                newList.appendChild(item);
            });

            // Insert after previous element
            previousNode.insertAdjacentElement('afterend', newList);
            previousNode = newList;
        });

        // Remove the original list
        list.remove();
    });

    // Serialize back to HTML string
    return doc.body.innerHTML;
}
